import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { PcbSpecificationTemplatePage } from '@/areas/pcb/PcbSpecificationTemplates/PcbSpecificationTemplatePage';
import { canViewInternalOrganizationSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/pcb-specification')({
    staticData: {
        access: { permissions: canViewInternalOrganizationSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PcbSpecificationTemplatePage />;
}
